/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseApiService from '../baseApi.service';

export default class AdministratorsService extends BaseApiService {
  readonly basePath: string = 'users/v1';
  constructor(props = null) {
    super(props);
  }

  exportAdministrator = async (
    params: object,
    onDownloadProgress: (progressEvent: any) => void
  ) => {
    return await this.getProgress('exportCSV', params, {}, progressEvent =>
      onDownloadProgress(progressEvent)
    ).then(async res => res?.data);
  };
}
